export default function SQLs_Inserts_Into() {
  return (
    <div>
      <h1>SQLs_Inserts_Into</h1>
      <p>Content for SQL Insert Into Select will go here.</p>
    </div>
  );
}
